(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1316],{

/***/ 51316:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ appliedFilters; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./components/appliedFilters/AppliedFilters.module.scss
var AppliedFilters_module = __webpack_require__(82847);
var AppliedFilters_module_default = /*#__PURE__*/__webpack_require__.n(AppliedFilters_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/appliedFilters/AppliedFilters.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var AppliedFilters = function AppliedFilters(_ref) {
  var filters = _ref.filters,
      onChange = _ref.onChange,
      selectedFilters = _ref.selectedFilters,
      currency = _ref.currency,
      isRU = _ref.isRU;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (AppliedFilters_module_default()).container,
    children: [filters.map(function (filter) {
      var type = filter.type;

      switch (type) {
        case 'range':
          {
            var _selectedFilters$slug, _selectedFilters$slug2, _selectedFilters$slug3, _selectedFilters$slug4;

            var slug = filter.slug,
                min = filter.min,
                max = filter.max,
                name = filter.name;
            var appliedMin = (_selectedFilters$slug = (_selectedFilters$slug2 = selectedFilters[slug]) === null || _selectedFilters$slug2 === void 0 ? void 0 : _selectedFilters$slug2.min) !== null && _selectedFilters$slug !== void 0 ? _selectedFilters$slug : min;
            var appliedMax = (_selectedFilters$slug3 = (_selectedFilters$slug4 = selectedFilters[slug]) === null || _selectedFilters$slug4 === void 0 ? void 0 : _selectedFilters$slug4.max) !== null && _selectedFilters$slug3 !== void 0 ? _selectedFilters$slug3 : max;
            var isVisible = +appliedMin !== +min || +appliedMax !== +max;

            if (isRU && Object.keys(currency).length) {
              appliedMin = (parseFloat(appliedMin) * currency.BYN.RUB).toFixed(0);
              appliedMax = (parseFloat(appliedMax) * currency.BYN.RUB).toFixed(0);
            }

            var reset = function reset() {
              var nextFilters = _objectSpread({}, selectedFilters);

              delete nextFilters[slug];
              if (onChange) onChange(nextFilters);
            };

            if (isVisible) {
              return /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
                className: (AppliedFilters_module_default()).item,
                title: name,
                onClick: reset,
                children: [appliedMin, " - ", appliedMax]
              }, slug);
            }
          }

        case 'checkbox':
          {
            var _slug = filter.slug,
                filterName = filter.name,
                options = filter.options;
            var appliedOptions = selectedFilters[_slug] || [];

            var _reset = function _reset(option) {
              return function () {
                var nextOptions = appliedOptions.filter(function (appliedOption) {
                  return appliedOption !== option;
                });

                var nextFilters = _objectSpread({}, selectedFilters);

                if (nextOptions.length > 0) {
                  nextFilters[_slug] = nextOptions;
                } else {
                  delete nextFilters[_slug];
                }

                if (onChange) onChange(nextFilters);
              };
            };

            if (appliedOptions.length > 0) {
              return appliedOptions.map(function (appliedOption) {
                var _options$find$name, _options$find;

                var optionTitle = (_options$find$name = (_options$find = options.find(function (option) {
                  return option.value === appliedOption;
                })) === null || _options$find === void 0 ? void 0 : _options$find.name) !== null && _options$find$name !== void 0 ? _options$find$name : '';

                if (optionTitle) {
                  return /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                    className: (AppliedFilters_module_default()).item,
                    title: filterName,
                    onClick: _reset(appliedOption),
                    children: optionTitle
                  }, "".concat(_slug, "-").concat(appliedOption));
                }
              });
            }
          }

        default:
          return null;
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
      className: (AppliedFilters_module_default()).reset,
      onClick: function onClick(e) {
        e.stopPropagation();
        if (onChange) onChange({});
      },
      children: "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C \u0432\u0441\u0435"
    })]
  });
};

/* harmony default export */ var appliedFilters_AppliedFilters = (AppliedFilters);
;// CONCATENATED MODULE: ./components/appliedFilters/index.js

/* harmony default export */ var appliedFilters = (appliedFilters_AppliedFilters);

/***/ }),

/***/ 82847:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"AppliedFilters_container__Pfw2z","item":"AppliedFilters_item__2h435","reset":"AppliedFilters_reset__yiufv","load":"AppliedFilters_load__0EM_u"};

/***/ })

}]);